import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/penalty-calculator/PenaltyCalculatorContent.tsx");
